import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'

export default [
  // ===
  // 會員中心
  // ===
  {
    path: '/member',
    name: 'member',
    component: () => lazyLoadView(import('@views/Member/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('auth/fetchMember');

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 預約紀錄
  // ===
  {
    path: '/member/reservation',
    name: 'member-reservation',
    component: () => lazyLoadView(import('@views/Member/ReservationList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // // ===
  // // 預約紀錄 內容頁
  // // ===
  // {
  //   path: '/member/reservation/:orderId',
  //   name: 'member-reservation-item',
  //   component: () => lazyLoadView(import('@views/Member/ReservationItem.Jtails')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const [
  //           currentReservationOrderItem
  //         ] = await Promise.all([
  //           store.dispatch('order/fetchReservationOrderItem', {
  //             orderId: routeTo.params.orderId
  //           }),
  //         ]);

  //         routeTo.params.orderItem = currentReservationOrderItem.items;

  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }), next);
  //       }
  //     },
  //     isLoginPage: true,
  //   },
  //   props: (route) => ({
  //     orderItem: route.params.orderItem || {},
  //   }),
  // },
  // ===
  // 新版預約紀錄 內容頁
  // ===
  {
    path: '/member/reservation/:containerUuid',
    name: 'member-reservation-item',
    component: () => lazyLoadView(import('@views/Member/ReservationItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentReservationOrderItem
            
          ] = await Promise.all([
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.containerUuid
            }),
            // store.dispatch('auth/fetchMemberPetList', {
            //   useCached: true
            // })
          ])
          if (!!currentReservationOrderItem.items.is_temp){ 
        
            alert('此訂單尚未成預約，無法查看')
            return next( {
              name: 'reservation-checkout'
            })
          } 
          // routeTo.params.orderItem = currentReservationOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({
      // containerItem: route.params.orderItem || {},
    }),
  },
  // ===
  // 包套方案
  // ===
  {
    path: '/member/prepaid',
    name: 'member-prepaid',
    component: () => lazyLoadView(import('@views/Member/PrepaidList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 包套方案 內容頁
  // ===
  {
    path: '/member/prepaid/:prepaidOrderId',
    name: 'member-prepaid-item',
    component: () => lazyLoadView(import('@views/Member/PrepaidItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentPrepaidOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchPrepaidOrderItem', {
              prepaidOrderId: routeTo.params.prepaidOrderId
            }),
          ]);

          routeTo.params.orderItem = currentPrepaidOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
    }),
  },
  // ===
  // 儲值金
  // ===
  {
    path: '/member/deposit',
    name: 'member-deposit',
    component: () => lazyLoadView(import('@views/Member/DepositList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(!store.state.merchant.currentMerchant?.components.includes('deposit')) {
            next({ name: '404' })
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 儲值金 內容頁
  // ===
  {
    path: '/member/deposit/:depositOrderId',
    name: 'member-deposit-item',
    component: () => lazyLoadView(import('@views/Member/DepositItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentDepositContainerItem
          ] = await Promise.all([
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.depositOrderId
            }),
          ]);

          routeTo.params.containerItem = currentDepositContainerItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({
      containerItem: route.params.containerItem || {},
    }),
  },
  // ===
  // 會員設定
  // ===
  {
    path: '/member/info',
    name: 'member-info',
    component: () => lazyLoadView(import('@views/Member/Info.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('auth/fetchMember');

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 寵物資料
  // ===
  {
    path: '/member/pet',
    name: 'member-pet',
    component: () => lazyLoadView(import('@views/Member/Pet.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      modePage: 'jtails'
    },
  },  
  // {
  //   path: '/member/user',
  //   name: 'member-pet',
  //   component: () => lazyLoadView(import('@views/Member/Pet.Jtails')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {

  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }), next);
  //       }
  //     },
  //     isLoginPage: true,
  //     modePage: 'dingbeauty'
  //   },
  // },
]
